// extracted by mini-css-extract-plugin
export var carousel = "Languages-module--carousel--2e072";
export var container = "Languages-module--container--5d2d4";
export var head = "Languages-module--head--5d005";